__turbopack_context__.v({
  "scroll": "brand-slider-module__w_c5jW__scroll",
  "slide-track": "brand-slider-module__w_c5jW__slide-track",
});
